import {
  IPlaceAddressComponent,
  IPlaceAutocompletePrediction,
  IZipLocationsResponse,
} from "../contracts/Location";
import { IZeosApiResponse } from "../contracts/ZeosApi";
import { getDataAsync } from "../ZeosApiExecutor";
import { ILocation } from "./interfaces/ILocation";

const BASE_URL = `/Location`;

export const Location: ILocation = {
  isNycZipCodeAsync: async (
    zipCode: string
  ): Promise<IZeosApiResponse<boolean>> => {
    return await getDataAsync<boolean>(
      `${BASE_URL}/IsNycZipCode/${zipCode}`,
      ""
    );
  },
  zipLocationsAsync: async (
    zipCode: string
  ): Promise<IZeosApiResponse<IZipLocationsResponse>> => {
    return await getDataAsync<IZipLocationsResponse>(
      `${BASE_URL}/ZipLocations/${zipCode}`,
      ""
    );
  },
  propertyLocationsAsync: async (
    propertyId: number
  ): Promise<IZeosApiResponse<IZipLocationsResponse>> => {
    return await getDataAsync<IZipLocationsResponse>(
      `${BASE_URL}/ZipLocations/Property/${propertyId}`,
      ""
    );
  },
  placesAutocompleteAsync: async (
    input: string,
    types?: string
  ): Promise<IZeosApiResponse<IPlaceAutocompletePrediction[]>> => {
    const params = new URLSearchParams();
    params.set("input", input);
    if (types) {
      params.set("types", types);
    }
    return await getDataAsync<IPlaceAutocompletePrediction[]>(
      `${BASE_URL}/PlacesAutocomplete?${params.toString()}`,
      ""
    );
  },
  placeDetailsAsync: async (
    placeId: string
  ): Promise<IZeosApiResponse<IPlaceAddressComponent[]>> => {
    return await getDataAsync<IPlaceAddressComponent[]>(
      `${BASE_URL}/PlaceDetails/${encodeURIComponent(placeId)}`,
      ""
    );
  },
};
